import { FC, ReactNode } from 'react';
import { ChakraPageTitle, PageWrapper } from 'app/components/Core';
import { getMobileOperatingSystem } from 'app/utils/utils';
import { MobileOperatingSystems } from 'types/enums';
import { externalLinks } from 'app/api.config';
import { Box, Button, Center, Divider, Link } from '@chakra-ui/react';

const DownloadButton: FC<{ href: string; children: ReactNode }> = ({
  children,
  href,
}) => (
  <Button
    as={Link}
    height="48px"
    width="280px"
    mb={4}
    href={href}
    textDecoration="none"
    _hover={{
      textDecoration: 'none',
      color: 'white',
    }}
    _focus={{
      textDecoration: 'none',
    }}
  >
    {children}
  </Button>
);
export const AppDownload: FC = () => {
  const mobileOperatingSystem = getMobileOperatingSystem();

  return (
    <>
      <PageWrapper height="auto" pb={2}>
        <Box pl={8} pb={6}>
          <ChakraPageTitle>Download Mobile App</ChakraPageTitle>
        </Box>
      </PageWrapper>
      <Divider />
      <Center height="350px" flexDirection="column">
        {mobileOperatingSystem === MobileOperatingSystems.IOS && (
          <DownloadButton href={externalLinks.mobileApp.IOS_APP_LINK}>
            Get Session for iOS
          </DownloadButton>
        )}
        {mobileOperatingSystem === MobileOperatingSystems.ANDROID && (
          <DownloadButton href={externalLinks.mobileApp.ANDROID_APP_LINK}>
            Get Session for Android
          </DownloadButton>
        )}
        {(!mobileOperatingSystem ||
          mobileOperatingSystem === MobileOperatingSystems.WINDOWS) && (
          <>
            <DownloadButton href={externalLinks.mobileApp.IOS_APP_LINK}>
              Get Session for iOS
            </DownloadButton>
            <DownloadButton href={externalLinks.mobileApp.ANDROID_APP_LINK}>
              Get Session for Android
            </DownloadButton>
          </>
        )}
      </Center>
    </>
  );
};
